<template>
    <account-form
        class="max-w-sm mx-auto pb-24"
        :enable-incomplete-registration="true"/>
</template>

<script>
import AccountForm from '@/components/forms/register/AccountForm';

export default {
    name: 'Account',
    components: {
        AccountForm,
    },
};
</script>
